import { intlFormat } from 'date-fns/intlFormat'
import { getLocale } from '../utils'

export const ORDINAL_DATE_FORMAT = 'do'
export const ORDINAL_MONTH_DAY_YEAR_FORMAT = 'MMM do, yyyy'

// Documentation on the options for formatting int'l dates
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
export const DATE_FORMATS_INTL = {
  TIME_STAMP_HOUR_MINUTE: {
    hour: 'numeric',
    minute: 'numeric',
  },
  DAY: {
    day: 'numeric',
  },
  DAY_OF_WEEK: {
    weekday: 'long',
  },
  DAY_OF_WEEK_MONTH_DAY: {
    day: 'numeric',
    month: 'long',
    weekday: 'long',
  },
  FULL_MONTH_DAY: {
    day: 'numeric',
    month: 'long',
  },
  MONTH: {
    month: 'short',
  },
  MONTH_DAY: {
    day: 'numeric',
    month: 'short',
  },
  MONTH_LONG: {
    month: 'long',
  },
  MONTH_SHORT: {
    month: 'short',
  },
  MONTH_SHORT_YEAR: {
    month: 'short',
    year: 'numeric',
  },
  MONTH_YEAR: {
    month: 'long',
    year: 'numeric',
  },
  YEAR_MONTH_DAY: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  },
  MONTH_DAY_YEAR: {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  },
  MED_MONTH_SHORT_DAY_FULL_YEAR: {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  },
  FULL_MONTH_DAY_YEAR: {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
  },
}

export interface Day {
  day: string
}

export interface DayOfWeek {
  weekday: string
}

export interface DayOfWeekMonthDay {
  day: string
  month: string
  weekday: string
}

export interface MonthDay {
  day: string
  month: string
}

export interface MonthLong {
  month: string
}

export interface MonthShort {
  month: string
}

export interface MonthYear {
  month: string
  year: string
}

export interface TimeStamp {
  hour: string
  minute: string
}

export interface YearMonthDay {
  day: string
  month: string
  year: string
}

export const formatDate = (
  date: string | Date,
  dFormat:
    | Day
    | DayOfWeek
    | DayOfWeekMonthDay
    | MonthDay
    | MonthLong
    | MonthShort
    | MonthYear
    | TimeStamp
    | YearMonthDay,
) => intlFormat(new Date(date), Object.assign(dFormat), { locale: getLocale() })
